<template>
    <div class="app-container">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="header-title">应用管理</span>
                <el-button style="float: right;" type="primary" size="small" icon="el-icon-plus" @click="handleCreate">新增应用</el-button>
            </div>

            <!-- Search Form -->
            <el-form :inline="true" :model="queryParams" class="search-form" size="small">
                <el-form-item label="应用ID">
                    <el-input v-model="queryParams.appId" placeholder="请输入应用ID" clearable></el-input>
                </el-form-item>
                <el-form-item label="应用名称">
                    <el-input v-model="queryParams.appName" placeholder="请输入应用名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="平台">
                    <el-select v-model="queryParams.platForm" placeholder="请选择平台" clearable>
                        <el-option label="扣子" value="01"></el-option>
                        <el-option label="阿里百炼" value="02"></el-option>
                        <el-option label="DeepSeek" value="03"></el-option>
                        <el-option label="Dify" value="04"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="类型">
                    <el-select v-model="queryParams.platFormType" placeholder="请选择类型" clearable>
                        <el-option label="智能体" :value="1"></el-option>
                        <el-option label="大模型" :value="2"></el-option>
                        <el-option label="机器人" :value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="queryParams.status" placeholder="请选择状态" clearable>
                        <el-option label="可用" :value="1"></el-option>
                        <el-option label="不可用" :value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
                    <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
                </el-form-item>
            </el-form>

            <!-- Table -->
            <el-table :data="list" v-loading="loading" style="width: 100%" border stripe :header-cell-style="{background:'#f5f7fa',color:'#606266'}">
                <el-table-column prop="id" label="ID" width="80" align="center"></el-table-column>
                <el-table-column prop="appId" label="应用ID" min-width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="appName" label="应用名称" min-width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="platForm" label="平台" width="120" align="center">
                    <template slot-scope="scope">
                        <el-tag effect="plain" v-if="scope.row.platForm === '01'">扣子</el-tag>
                        <el-tag effect="plain" type="success" v-else-if="scope.row.platForm === '02'">阿里百炼</el-tag>
                        <el-tag effect="plain" type="warning" v-else-if="scope.row.platForm === '03'">DeepSeek</el-tag>
                        <el-tag effect="plain" type="info" v-else-if="scope.row.platForm === '04'">Dify</el-tag>
                        <span v-else>{{ scope.row.platForm }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="platFormType" label="类型" width="100" align="center">
                    <template slot-scope="scope">
                        <el-tag size="small" v-if="scope.row.platFormType === 1">智能体</el-tag>
                        <el-tag size="small" type="warning" v-else-if="scope.row.platFormType === 2">大模型</el-tag>
                        <el-tag size="small" type="success" v-else-if="scope.row.platFormType === 3">机器人</el-tag>
                        <el-tag size="small" type="info" v-else>未知</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="状态" width="100" align="center">
                    <template slot-scope="scope">
                        <el-switch
                            v-model="scope.row.status"
                            :active-value="1"
                            :inactive-value="0"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            @change="handleStatusChange(scope.row)">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="200" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" icon="el-icon-edit" circle @click="handleEdit(scope.row)" title="编辑"></el-button>
                        <el-button size="mini" type="success" icon="el-icon-key" circle @click="handleViewKey(scope.row)" v-if="scope.row.status === 1" title="查看Key"></el-button>
                        <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="handleDelete(scope.row)" title="删除"></el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- Pagination -->
            <div class="pagination-container">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="queryParams.currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="queryParams.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </el-card>

        <!-- Edit/Add Dialog -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false">
            <el-form :model="form" :rules="rules" ref="dataForm" label-width="100px">
                <el-form-item label="应用ID" prop="appId">
                    <el-input v-model="form.appId" placeholder="请输入应用ID"></el-input>
                </el-form-item>
                <el-form-item label="应用名称" prop="appName">
                    <el-input v-model="form.appName" placeholder="请输入应用名称"></el-input>
                </el-form-item>
                <el-form-item label="平台" prop="platForm">
                    <el-select v-model="form.platForm" placeholder="请选择平台" style="width: 100%">
                        <el-option label="扣子" value="01"></el-option>
                        <el-option label="阿里百炼" value="02"></el-option>
                        <el-option label="DeepSeek" value="03"></el-option>
                        <el-option label="Dify" value="04"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="类型" prop="platFormType">
                    <el-radio-group v-model="form.platFormType">
                        <el-radio :label="1">智能体</el-radio>
                        <el-radio :label="2">大模型</el-radio>
                        <el-radio :label="3">机器人</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="Token" prop="token">
                    <el-input v-model="form.token" placeholder="请输入Token" show-password></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitForm" :loading="submitLoading">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getAppList, getAppDetail, saveApp, updateAppStatus, getApplicationAppKey, deleteApp } from '@/api/ai/application'

export default {
    name: 'applicationList',
    data() {
        return {
            queryParams: {
                currentPage: 1,
                pageSize: 20,
                appId: '',
                appName: '',
                platForm: '',
                platFormType: null,
                status: null
            },
            list: [],
            total: 0,
            loading: false,
            dialogVisible: false,
            dialogTitle: '',
            submitLoading: false,
            form: {
                id: null,
                appId: '',
                appName: '',
                platForm: '',
                platFormType: 1,
                token: ''
            },
            rules: {
                appId: [{ required: true, message: '请输入应用ID', trigger: 'blur' }],
                appName: [{ required: true, message: '请输入应用名称', trigger: 'blur' }],
                platForm: [{ required: true, message: '请选择平台', trigger: 'change' }],
                platFormType: [{ required: true, message: '请选择类型', trigger: 'change' }]
            }
        }
    },
    created() {
        this.fetchData()
    },
    methods: {
        fetchData() {
            this.loading = true
            getAppList(this.queryParams).then(res => {
                this.list = res.list || []
                this.total = res.total || 0
                this.loading = false
            }).catch(err => {
                this.loading = false
                // Error handling is mainly done in http.js but we can add loading reset
            })
        },
        handleSearch() {
            this.queryParams.currentPage = 1
            this.fetchData()
        },
        resetQuery() {
            this.queryParams = {
                currentPage: 1,
                pageSize: 20,
                appId: '',
                appName: '',
                platForm: '',
                platFormType: null,
                status: null
            }
            this.fetchData()
        },
        handleSizeChange(val) {
            this.queryParams.pageSize = val
            this.fetchData()
        },
        handleCurrentChange(val) {
            this.queryParams.currentPage = val
            this.fetchData()
        },
        handleCreate() {
            this.form = {
                id: null,
                appId: '',
                appName: '',
                platForm: '',
                platFormType: 1,
                token: ''
            }
            this.dialogTitle = '新增应用'
            this.dialogVisible = true
            this.$nextTick(() => {
                this.$refs.dataForm.clearValidate()
            })
        },
        handleEdit(row) {
            this.dialogTitle = '编辑应用'
            this.dialogVisible = true
             // Fetch detail or just use row data? User said "GET /app/detail".
             // Let's call detail to be safe, or just use row if it has everything.
             // The API getAppDetail takes id or appId.
             getAppDetail({id: row.id}).then(res => {
                 this.form = {
                     id: res.id,
                     appId: res.appId,
                     appName: res.appName,
                     platForm: res.platForm,
                     platFormType: res.platFormType,
                     token: res.token, // Assuming token is returned in detail
                     status: res.status
                 }
                  this.$nextTick(() => {
                    this.$refs.dataForm.clearValidate()
                })
             })
        },
        submitForm() {
            this.$refs.dataForm.validate(valid => {
                if (valid) {
                    this.submitLoading = true
                    saveApp(this.form).then(res => {
                        this.$message.success('操作成功')
                        this.dialogVisible = false
                        this.fetchData()
                    }).finally(() => {
                        this.submitLoading = false
                    })
                }
            })
        },
        handleStatusChange(row) {
            let status = row.status
            // Optimistic update already happened due to v-model.
            // But if it fails we need to revert.
            // Actually it's better to not immediate change, or just call API.
            // Since used v-model, row.status is already changed.
            updateAppStatus({ id: row.id, status: status }).then(res => {
                this.$message.success('状态已更新')
            }).catch(err => {
                row.status = status === 1 ? 0 : 1 // Revert
            })
        },
        handleViewKey(row) {
            getApplicationAppKey({ appId: row.appId }).then(res => {
                // res should be apiKey string?
                // "返回：apiKey"
                // It might be an object wrapping it or just string?
                // Based on http.js: resolve(res.data.value). So it returns the value directly.
                const apiKey = res // Assuming res is the string or object
                this.$alert(apiKey, 'API Key', {
                    confirmButtonText: '复制',
                    callback: action => {
                        if (action === 'confirm') {
                           this.copyToClipboard(apiKey)
                        }
                    }
                });
            })
        },
        copyToClipboard(text) {
             const input = document.createElement('input');
             input.value = typeof text === 'string' ? text : JSON.stringify(text);
             document.body.appendChild(input);
             input.select();
             document.execCommand('copy');
             document.body.removeChild(input);
             this.$message.success('已复制到剪贴板');
        },
        handleDelete(row) {
            this.$confirm('确认删除该应用吗？此操作将永久删除该应用。', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteApp({ id: row.id }).then(res => {
                    this.$message.success('删除成功')
                    this.fetchData()
                })
            }).catch(() => {
                // User cancelled
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.app-container {
    padding: 20px;
    background-color: #f0f2f5;
    min-height: calc(100vh - 84px);
    .box-card {
        border-radius: 8px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
    }
    .header-title {
        font-size: 18px;
        font-weight: bold;
        color: #303133;
        line-height: 32px;
    }
    .search-form {
        margin-bottom: 10px;
        .el-form-item {
            margin-bottom: 10px;
        }
    }
    .pagination-container {
        margin-top: 20px;
        text-align: right;
    }
}
</style>
